import React from 'react';
import '../assets/css/SideBar.css';
import { Auth } from 'aws-amplify';
import { showDefaultAlert } from '../utils/alerts';
import { useNavigate } from 'react-router-dom';

export default function SideBar({ isCollapsed = false, onToggleCollapse }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
    }
  }

  function handleCollapseToggle() {
    if (onToggleCollapse) {
      onToggleCollapse();
    }
    setIsOpen(false);
  }

  function handleNavigate(path) {
    navigate(path);
    setIsOpen(false);
  }

  return (
    <>
      <button
        className={`side-toggle ${isCollapsed ? 'is-collapsed' : ''}`}
        aria-label="Toggle sidebar"
        aria-expanded={isOpen}
        aria-controls="sidebar"
        onClick={() => {
          if (isCollapsed) {
            handleCollapseToggle();
            return;
          }
          setIsOpen((prev) => !prev);
        }}
      >
        ☰
      </button>
      <div
        className={`side-overlay ${isOpen ? 'is-open' : ''}`}
        role="presentation"
        onClick={() => setIsOpen(false)}
      />
      <div id="sidebar" className={`side ${isOpen ? 'is-open' : ''} ${isCollapsed ? 'is-collapsed' : ''}`}>
        <div className="side-header">
          <div className="side-brand">
            <span className="side-brand__title">Admin Console</span>
            <span className="side-brand__subtitle">Operations</span>
          </div>
          <button
            className="side-collapse"
            type="button"
            onClick={handleCollapseToggle}
            aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {isCollapsed ? '»' : '«'}
          </button>
        </div>
        <li className="side-link row" onClick={() => handleNavigate('/')}>Home</li>
        <li className="side-link row" onClick={() => handleNavigate('/user')}>User</li>
        <li className="side-link row" onClick={() => handleNavigate('/vehicles')}>Vehicles</li>
        <li className="side-link row" onClick={() => handleNavigate('/listings')}>Listings</li>
        <li className="side-link row" onClick={() => handleNavigate('/outage')}>API Outage</li>
        <li className="side-link row" onClick={() => handleNavigate('/promotion')}>Promotions</li>
        <li className="side-link row" onClick={() => handleNavigate('/dealer')}>Dealer</li>
        <li className="side-link row" onClick={() => handleNavigate('/featuredDealer')}>Featured Dealer</li>
        <li className="side-link row" onClick={() => handleNavigate('/featuredVehicles')}>Featured Vehicles</li>
        <li className="side-link row" onClick={() => handleNavigate('/vehicleDefinition')}>Vehicle Definition</li>
        <li className="side-link row" onClick={() => handleNavigate('/ParkingDetails')}>Parking</li>
        <li className="side-link row" onClick={() => handleNavigate('/FuelStationDetails')}>Fuel Stations</li>
        <li className="side-link row" onClick={() => handleNavigate('/tenants')}>Tenants</li>
        <div className='signout'>
          <button className="btn btn-danger side-signout-btn" onClick={() => signOut()}>SignOut</button>
        </div>
      </div>
    </>
  );
}
